/* eslint-disable jsx-a11y/img-redundant-alt */
import { useEffect } from "react";
import osman from "../../images/doctors/osman.jpg";
import "./about.css";
import { MdMarkEmailUnread } from "react-icons/md";
import { BiSolidMobileVibration } from "react-icons/bi";
const About = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="about-page">
      <div className="about-wrapper">
        <div className="about-img-wrapper">
          <img src={osman} alt="osman" />
        </div>
        <div className="about-info-wrapper">
          <div className="name-title">
            <div className="name">Ahmmed Osman Elhady</div>
            <strong>MERN Stack Developer</strong>
          </div>
          <div className="email">
            <MdMarkEmailUnread color="#ef7b51" size={20} />
            <p>ahmedosmanalisaleh@gmail.com</p>
          </div>

          <div className="mobile">
            <div className="item">
              <BiSolidMobileVibration color="red" size={20} />
              <p>01001312749</p>
            </div>
            <div className="item">
              <BiSolidMobileVibration color="green" size={20} />
              <p>01101476854</p>
            </div>
        
          </div>
          <div className="footer-title">Yes, We can help.</div>
        </div>
      </div>
    </div>
  );
};

export default About;
